import { AxiosError } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { sendForApproval } from './sendForApproval';
import { useTranslation } from 'react-i18next';
import { showNotification } from '../../shared/notification/toastNotification';

type Props = {
    listId: string;
};

export const useSendForApproval = ({ listId }: Props) => {
    const { t } = useTranslation();

    const mutation = useMutation<void, AxiosError<{ message?: string }>, string>(
        ['selectionListSendForApproval', listId],
        (userEmail: string) => sendForApproval({ listId, userEmail }),
        {
            onSuccess: () => {
                showNotification(t('notifications.useSendForApproval.success'));
            }
        }
    );

    return {
        ...mutation,
        errorMessage: mutation.error?.response?.data?.message
    };
};
